import { TaBasicArrow } from '@tav-ui/components/basic-arrow'
import { TaBasicHelp } from '@tav-ui/components/basic-help'
import { TaBasicTitle } from '@tav-ui/components/basic-title'
import { TaButton } from '@tav-ui/components/button'
import { TaButtonGroup } from '@tav-ui/components/button-group'
import { TaButtonModal } from '@tav-ui/components/button-modal'
import { TaButtonPopconfirm } from '@tav-ui/components/button-popconfirm'
import { TaConfigProvider } from '@tav-ui/components/config-provider'
import { TaContainerCollapse } from '@tav-ui/components/container-collapse'
import { TaContainerScroll } from '@tav-ui/components/container-scroll'
import { TaContextMenu } from '@tav-ui/components/context-menu'
import { TaCountDown, TaCountDownButton } from '@tav-ui/components/count-down'
import { TaCountTo } from '@tav-ui/components/count-to'
import { TaDrawer } from '@tav-ui/components/drawer'
import { TaDropdown } from '@tav-ui/components/dropdown'
import { TaFollow } from '@tav-ui/components/follow'
import { ApiSelect, RadioButtonGroup, TaForm } from '@tav-ui/components/form'
import { TaIcon } from '@tav-ui/components/icon'
import { TaIconPicker } from '@tav-ui/components/icon-picker'
import { TaIconSvg } from '@tav-ui/components/icon-svg'
import { TaInputNumberRange } from '@tav-ui/components/input-number-range'
import { TaLoading } from '@tav-ui/components/loading'
import { TaMemberSelect } from '@tav-ui/components/member-select'
import { TaModal } from '@tav-ui/components/modal'
import { TaQrCode } from '@tav-ui/components/qr-code'
import { TaScrollbar } from '@tav-ui/components/scrollbar'
import { TaStrengthMeter } from '@tav-ui/components/strength-meter'
import { TaTable, TableAction, TableImg } from '@tav-ui/components/table'
import { TaTablePro } from '@tav-ui/components/table-pro'
import { TaTableTags } from '@tav-ui/components/table-tags'
import { TaTime } from '@tav-ui/components/time'
import { TaTimeLine } from '@tav-ui/components/time-line'
import { TaCollapseTransition } from '@tav-ui/components/transition'
import { TaTree } from '@tav-ui/components/tree'
import { TaUpload } from '@tav-ui/components/upload'
import { TaVerify, TaVerifyRotate } from '@tav-ui/components/verify'
import { TaVirtualScroll } from '@tav-ui/components/virtual-scroll'
import { TaCountButton } from '@tav-ui/components/count-button'
import { TaCascadeProSelect } from '@tav-ui/components/cascade-pro'
import { TaFileView } from '@tav-ui/components/file-view'
import {
  TaFile,
  TaFileActionUpload,
  TaFileActionUploadLink,
  TaFileCard,
  TaFileCards,
  TaFileLog,
  TaFilePreview,
  TaFileTable,
  TaFileTypeSelect,
  TaFileUpload,
  TaFileUploadPreview,
  TaFileVersion,
} from '@tav-ui/components/file'
import { TaEditor } from '@tav-ui/components/editor'
import {
  TaPermissionDataQuery,
  TaPermissionFragment,
  TaPermissionQuery,
  TaPermissions,
  TaTablePermissionDataQuery,
} from '@tav-ui/components/permission'

import type { Plugin } from 'vue'

export default [
  TaBasicArrow,
  TaBasicHelp,
  TaBasicTitle,
  TaButton,
  TaButtonGroup,
  TaButtonModal,
  TaButtonPopconfirm,
  TaContainerCollapse,
  TaContainerScroll,
  TaConfigProvider,
  TaContextMenu,
  TaCountDown,
  TaCountDownButton,
  TaCountTo,
  TaDrawer,
  TaDropdown,
  TaFollow,
  TaForm,
  ApiSelect,
  RadioButtonGroup,
  TaIcon,
  TaIconPicker,
  TaIconSvg,
  TaInputNumberRange,
  TaLoading,
  TaMemberSelect,
  TaModal,
  TaQrCode,
  TaScrollbar,
  TaStrengthMeter,
  TaTable,
  TableAction,
  TableImg,
  TaTablePro,
  TaTableTags,
  TaTime,
  TaTimeLine,
  TaCollapseTransition,
  TaTree,
  TaUpload,
  TaVerify,
  TaVerifyRotate,
  TaVirtualScroll,
  TaCountButton,
  TaCascadeProSelect,
  TaFileView,
  TaFile,
  TaFileTypeSelect,
  TaFileActionUpload,
  TaFileActionUploadLink,
  TaFileTable,
  TaFileVersion,
  TaFilePreview,
  TaFileLog,
  TaFileCards,
  TaFileCard,
  TaFileUpload,
  TaFileUploadPreview,
  TaEditor,
  TaPermissionFragment,
  TaPermissions,
  TaPermissionQuery,
  TaPermissionDataQuery,
  TaTablePermissionDataQuery,
] as Plugin[]
